import "./UnlodgedCollateralComponent.scss";
import {UnlodgedTableRow} from "../../models/table/UnlodgedTableRow";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {UnlodgedCollateral} from "../../../../../types/PortfolioMarginResult";
import {LodgeAmountService} from "../../service/lodge-amount/LodgeAmountService";
import {IOnChanges, IOnChangesObject} from "angular";

export const UnlodgedCollateralComponent = "unlodgedCollateral";

export function unlodgedCollateralComponent() {
    return {
        templateUrl: "app/portfolio/templates/collateral/lodge/unlodged/UnlodgedCollateralComponent.html",
        bindings: {
            rows: "<",
            onLodgeSpecific: "&",
            onLodgeGeneral: "&"
        },
        controllerAs: "ctrl",
        controller: UnlodgedCollateralComponentController
    };
}

export class UnlodgedCollateralComponentController implements IOnChanges {

    public rows: Array<UnlodgedTableRow>;
    public onLodgeSpecific: ComponentCallback;
    public onLodgeGeneral: ComponentCallback;

    public totalValue: number;

    /** @ngInject */
    public constructor(private lodgeAmountService: LodgeAmountService) {

    }

    public $onChanges(changes: IOnChangesObject): void {
        if (this.rows == null) {
            this.totalValue = 0;
        } else {
            this.totalValue = this.rows
                                  .map(r => r.data)
                                  .map(d => d.value)
                                  .reduce((acc, next) => acc + next, 0);
        }
    }

    public async lodgeGeneral(collateral: UnlodgedCollateral) {
        const max = collateral.quantity;
        const quantity = await this.lodgeAmountService.openLodgeAmount(max);
        this.onLodgeGeneral({
            code: collateral.securityCode,
            quantity
        });
    }

    public async lodgeSpecific(collateral: UnlodgedCollateral) {
        const max = collateral.quantity;
        const quantity = await this.lodgeAmountService.openLodgeAmount(max);
        this.onLodgeSpecific({
            code: collateral.securityCode,
            quantity
        });
    }
}
